const NAME = "customerly";

export { NAME };
